import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Exact } from "@Helpers/types/exact";
import type { CurrencyDetail, SymbolDetail } from "@ServerTypes/currency/currency.schema";

export interface CurrencyState {
  currencyDetail?: CurrencyDetail;
  symbolDetail?: SymbolDetail;
  isDisable?: boolean;
}

const currencySlice = createSlice({
  name: "currencyDetails",
  initialState: {} as CurrencyState,
  reducers: {
    setCurrencyDetails: (_state: CurrencyState, action: PayloadAction<CurrencyState>) => ({
      ...action.payload,
    }),
  },
});

const { setCurrencyDetails: _setCurrencyDetailsRaw } = currencySlice.actions;

/**
 * Object-payload action creator wrapped with `Exact<>` so excess properties
 * are caught even when the payload is passed through a variable.
 */
export const setCurrencyDetails = <T extends Exact<CurrencyState, T>>(payload: T) => _setCurrencyDetailsRaw(payload);

export const currencyDetails = currencySlice.reducer;

export default currencySlice.reducer;
